import store from 'src/js/store';
import showHighlighter from '../actions/show';

function show(elements, options = {}) {
  store.dispatch(showHighlighter(elements, options));
}

export default show;
